import { z } from 'zod';

const ListResponse = (schema: z.ZodSchema) => {
  return z.object({
    items: z.array(schema)
  });
};

export default ListResponse;
